import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthServices } from '../core/auth/services/auth.service';
import { LoadingService } from '../core/services/loading.service';

@Injectable()
export class AuthInterceptorInterceptor implements HttpInterceptor {
  constructor(private auth: AuthServices,private loading: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request).pipe(
      catchError((err) => {
        if ([401].includes(err.status) || [403].includes(err.status)) {
           this.auth.logout();
        }
        const error = err.error?.message || err.statusText;
        this.loading.hideLoading()
        return throwError(() => err);
      })
    );
  }
}
